import _isEmpty from "lodash/isEmpty";
import _split from "lodash/split";
import { createBrowserHistory } from 'history';
import { useEffect, useMemo, useState } from 'react';
const getPreviewState = _ref => {
  let {
    pathname
  } = _ref;
  const [, preview,, courseHash, chapterHash] = _split(pathname, '/');
  if (preview === 'preview' && !_isEmpty(courseHash) && !_isEmpty(chapterHash)) {
    return {
      chapterHash,
      courseHash,
      isPreview: true
    };
  }
  return {
    isPreview: false
  };
};
export const usePreview = () => {
  const history = useMemo(createBrowserHistory, []);
  const [state, setState] = useState(getPreviewState(history.location));
  useEffect(() => history.listen(location => {
    setState(getPreviewState(location));
  }), [history]);
  return state;
};